/* ORZO — pasek kategorii karty.
   Kliknięcie przewija do kategorii, a podczas przewijania podświetla się ta,
   którą gość właśnie czyta. Filtry diety chowają pojedyncze pozycje. */
(function () {
  'use strict';
  if (window.__orzoKarta) return;
  window.__orzoKarta = true;
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  function barH() {
    return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--barh'), 10) || 80;
  }

  $$('[data-karta]').forEach(function (karta) {
    var panel = karta.querySelector('[data-karta-panel]');
    var lista = karta.querySelector('[data-karta-lista]');
    if (!panel || !lista) return;
    var nav = panel.querySelector('.fg-kat');
    var pusto = karta.querySelector('[data-karta-pusto]');
    var diet = [];

    function offset() { return barH() + panel.offsetHeight + 12; }

    var aktualna = null;
    function ustaw(handle) {
      if (handle === aktualna) return;
      aktualna = handle;
      $$('[data-cat]', panel).forEach(function (a) {
        var on = a.dataset.cat === handle;
        if (on) {
          a.setAttribute('aria-current', 'true');
          if (nav && nav.scrollWidth > nav.clientWidth) {
            var l = a.offsetLeft - nav.offsetLeft, r = l + a.offsetWidth;
            if (l < nav.scrollLeft) nav.scrollTo({ left: l - 16 });
            else if (r > nav.scrollLeft + nav.clientWidth) nav.scrollTo({ left: r - nav.clientWidth + 16 });
          }
        } else a.removeAttribute('aria-current');
      });
    }

    panel.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-cat]');
      if (a) {
        var head = document.getElementById('kategoria-' + a.dataset.cat);
        if (!head) return;
        head = head.querySelector('h2') || head;
        e.preventDefault();
        scrollTo({ top: head.getBoundingClientRect().top + scrollY - offset(), behavior: 'smooth' });
        history.replaceState(null, '', '#kategoria-' + a.dataset.cat);
        ustaw(a.dataset.cat);
        return;
      }
      var d = e.target.closest('[data-diet]');
      if (d) {
        var i = diet.indexOf(d.dataset.diet);
        if (i === -1) diet.push(d.dataset.diet); else diet.splice(i, 1);
        d.setAttribute('aria-pressed', String(i === -1));
        filtruj();
      }
    });

    function filtruj() {
      var razem = 0;
      $$('[data-catgroup]', lista).forEach(function (g) {
        var n = 0;
        $$('.row', g).forEach(function (r) {
          var dd = (r.getAttribute('data-diet') || '').split(/\s+/);
          var ok = diet.every(function (x) { return dd.indexOf(x) !== -1; });
          r.hidden = !ok;
          if (ok) n++;
        });
        g.hidden = n === 0;
        var head = lista.querySelector('[data-cat-head="' + g.getAttribute('data-catgroup') + '"]');
        if (head) head.hidden = n === 0;
        var link = panel.querySelector('[data-cat="' + g.getAttribute('data-catgroup') + '"]');
        if (link) link.hidden = n === 0;
        razem += n;
      });
      if (pusto) pusto.hidden = razem > 0;
    }
    karta.addEventListener('click', function (e) {
      if (!e.target.closest('[data-clearf]')) return;
      diet = [];
      $$('[data-diet]', panel).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      filtruj();
    });

    var heads = $$('[data-cat-head]', lista);
    function spy() {
      var linia = offset() + 40, aktywna = null;
      heads.forEach(function (h) { var t = h.querySelector('h2') || h; if (!h.hidden && t.getBoundingClientRect().top <= linia) aktywna = h; });
      var rect = lista.getBoundingClientRect();
      if (rect.bottom < linia || rect.top > innerHeight) aktywna = null;
      ustaw(aktywna ? aktywna.getAttribute('data-cat-head') : (heads[0] && rect.top < linia ? heads[0].getAttribute('data-cat-head') : ''));
    }
    var t = 0;
    addEventListener('scroll', function () { if (!t) t = setTimeout(function () { t = 0; spy(); }, 60); }, { passive: true });
    spy();

    if (location.hash.indexOf('#kategoria-') === 0) {
      var cel = document.getElementById(location.hash.slice(1));
      if (cel && karta.contains(cel)) setTimeout(function () {
        cel = cel.querySelector('h2') || cel;
        scrollTo({ top: cel.getBoundingClientRect().top + scrollY - offset() });
      }, 60);
    }
  });
}());
